import * as React from 'react';
import { classes, style } from 'typestyle';
import { mediaLargeTablet, mediaUpToLargeTablet } from '../utilities/mediaQueries';
import { spacing } from '../../../theme/spacing';

const styles = style(
  {
    textAlign: 'center',
    position: 'relative',
    $nest: {
      '& h2': {
        margin: 0,
      },
    },
  },
  mediaUpToLargeTablet({
    padding: `${spacing.LARGE} 0`,
  }),
  mediaLargeTablet({
    padding: `${spacing.XXLARGE} 0`,
  })
);

export type GroupHeadingProps = { className: string };

export const GroupHeading: React.FC<GroupHeadingProps> = ({ children, className }) => (
  <div className={classes(styles, className)}>{children}</div>
);
